import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';
export class BedStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      bedsList: [],
      roomType: [],
      bedType: [],
      bed: {},
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      action: null,
    });
  }
  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.bedsList = [];
  }

  async setData(task, data, getBed = true, id) {
    this[task] = data;
    let queryOption = {};
    queryOption.offset = this.offset;
    queryOption.limit = this.limit;
    queryOption.search = this.search;
    queryOption.sort = this.sort;
    queryOption.order = this.order;
    if (getBed) {
      this.getBedsList(id, queryOption);
    }
  }

  async getBedsList(id, queryOption) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/bed/subgroup/${id}`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const beds = res.body || {};
        return (this.bedsList = beds);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getBedsBySubgroupIds(subgroupIds) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/bed/subgroup`;
      const res = await rp
        .post(url, {
          body: {
            subgroups: subgroupIds,
          },
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const beds = res.body || {};
        return (this.bedsList = beds);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getBedPatient(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/bed/patient/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const bed = res.body || {};
        return bed;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getRoomType() {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/roomtype`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const roomType = res.body || {};
        return (this.roomType = roomType);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getBedType() {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/bedtype`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const bedType = res.body || {};
        return (this.bedType = bedType);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createBed(data, id) {
    this.loading = true;
    try {
      const detail = {
        name: data.bed,
        bedTypeId: data.bedType,
        roomName: data.room,
        roomTypeId: data.roomType,
        subGroupId: id,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/bed`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateBed(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.bed,
        bedTypeId: data.bedType,
        roomName: data.room,
        roomTypeId: data.roomType,
        subGroupId: data.subGroupId,
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/bed/${data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateBeds(data) {
    this.loading = true;
    try {
      const detail = {
        subgroupId: data.subgroupId,
        beds: data.beds,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/bed/update/current`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteBed(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/bed/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async discharge(data) {
    this.loading = true;
    try {
      // unassigned device
      const patientRes = await rp
        .get(`${config.api.url}/${config.api.version}/patient/${data.patientId}`, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (patientRes && patientRes.statusCode === 200) {
        const devices = patientRes.body.devices;
        if (devices) {
          devices.forEach(async (device) => {
            rp.post(`${config.api.url}/${config.api.version}/device/unassign`, {
              body: {
                device_id: device.id,
              },
              json: true,
              authorization: true,
              resolveWithFullResponse: true,
              headers: {
                ...getTenantHeaders(),
              },
            }).auth(null, null, true, getToken('id_token'));
          });
        }
      }

      // discharge patient
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/bed/discharge`, {
          body: {
            id: data.id,
            patient_id: data.patientId,
          },
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
      // let user = this.user.map((data) => {
      //   if (data.id === res.body.id) {
      //     data = res.body
      //     data.alert = {};
      //     data.device = {
      //       action: {
      //         changed: {
      //           "a": null,
      //           "f": null,
      //           "b": null,
      //           "m": null,
      //         }
      //       }
      //     }
      //   }
      //   return data;
      // });
      // this.user = user;
      // return res;
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async findById(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/bed/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const data = res.body || {};
        this.bed = data;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new BedStore();
